import { Dropdown } from 'react-bootstrap'
import { useIntlContext } from '../../IntlProviderWrapper'
import { useStore } from 'hooks'
import CustomDropdownToggle from './CustomDropdownToggle'
import './Style.scss'

const LanguageDropdown = () => {
  const appStore = useStore('appStore')
  const { switchToEnglish, switchToRussian, switchToKyrgyz } = useIntlContext()

  return (
    <Dropdown drop="left">
      <Dropdown.Toggle
        as={CustomDropdownToggle}
        name={appStore.currentLanguage}
        className="lang-dropdown-toogle"
      />
      <Dropdown.Menu>
        <Dropdown.Item onClick={switchToEnglish}>English</Dropdown.Item>
        <Dropdown.Item onClick={switchToRussian}>Русский</Dropdown.Item>
        <Dropdown.Item onClick={switchToKyrgyz}>Кыргызча</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LanguageDropdown
